/** How a right-click on a table cell behaves. */
export type CellRightClickPref = 'menu' | 'copy';

export const CELL_RIGHT_CLICK_KEY = 'display.cellRightClick';

/** Anything that isn't the literal string 'copy' resolves to the default, 'menu'. */
export function coerceCellRightClick(v: unknown): CellRightClickPref {
  return v === 'copy' ? 'copy' : 'menu';
}
